/**
 * Flowing wave lines — CSS-only animation, JS sets paths once.
 * Generates unique sine-wave stroke paths per line, then CSS
 * translate3d(-50%) with linear timing creates a seamless loop.
 */
(function () {
  function initContainer(container) {
    var lines = container.querySelectorAll(".wt-lines__line");
    if (!lines.length) return;

    var total = lines.length;
    var spacing = parseFloat(container.dataset.waveLineSpacing) || 8;
    var speedSetting = parseFloat(container.dataset.waveSpeed) || 5;
    var speedMul = speedSetting / 5; // 1=0.2×, 5=1×, 10=2×

    for (var i = 0; i < total; i++) {
      var svg = lines[i];
      var path = svg.querySelector("path");
      if (!path) continue;

      // Distribute y-centers with configurable spacing, centered in viewBox
      var span = spacing * (total - 1);
      var yStart = 50 - span / 2;
      var yCenter = total > 1 ? yStart + spacing * i : 50;
      // Clamp to stay within viewBox (5–95)
      yCenter = Math.max(5, Math.min(95, yCenter));

      // Vary amplitude (5–15)
      var amplitude = 5 + ((i * 7 + 3) % 11);

      // Vary frequency: full cycles per 1500 units (integer for seamless tiling)
      var freq = 2 + (i % 5); // 2–6 cycles

      // Half-cycle width
      var hc = 1500 / (freq * 2);

      // Build path using Q + T (smooth quadratic Bézier)
      var qx = hc / 2;
      var qy = yCenter - amplitude;
      var d = "M0," + yCenter + " Q" + qx + "," + qy + " " + hc + "," + yCenter;
      for (var x = hc * 2; x <= 3000; x += hc) {
        d += " T" + x + "," + yCenter;
      }
      path.setAttribute("d", d);

      // Stroke: opacity fades toward edges, brighter in middle
      var t = total > 1 ? i / (total - 1) : 0.5;
      var opacity = 0.04 + 0.06 * (1 - Math.abs(t - 0.5) * 2);
      path.setAttribute("stroke", "rgba(255,255,255," + opacity.toFixed(3) + ")");
      path.setAttribute("stroke-width", (1 + (1 - Math.abs(t - 0.5) * 2) * 0.8).toFixed(1));

      // Animation timing: varied duration + staggered delay, scaled by speed
      var baseDuration = 18 + i * 2.5 + ((i % 3) * 4);
      var duration = baseDuration / speedMul;
      var delay = (i * 1.7 + ((i % 4) * 1.3)) / speedMul;
      svg.style.animationDuration = duration + "s";
      svg.style.animationDelay = "-" + delay + "s";
    }
  }

  // Initialize all wave line containers on the page
  document.querySelectorAll("[data-wave-lines]").forEach(initContainer);

  // Re-initialize when Shopify editor loads/reloads a section
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener("shopify:section:load", function (e) {
      e.target.querySelectorAll("[data-wave-lines]").forEach(initContainer);
    });
  }
})();
